@if (showMarketHelp) {
    <ms-market-help [optionGroup]="optionGroup" [eventHelpText]="eventHelpText" />
}
@if (isTeamGroupingEnabled()) {
    <ms-team-grouping-tab-bar [event]="event" [optionGroup]="optionGroup" (teamGroupingChange)="onTeamGroupingChange($event)" />
}
<div class="option-group-container goal-scorer-container" [style.--option-group-rows]="visibleOptions().length" [ngClass]="scoreOptionsClass()">
    @if (showHeaders()) {
        <div class="option-group-header">
            <span></span>
            @for (header of headers(); track header.name) {
                <span class="option-header-name"> {{ header.name }} </span>
            }
        </div>
    }
    <ng-container *rxFor="let group of optionsToDisplay$; strategy: 'immediate'; trackBy: trackGroup; renderCallback: groupsRendered$">
        <div [ngClass]="isShowOptionImage ? 'attribute-key participant-jersey' : 'attribute-key'">
            @if (isShowHeadshotImage || isShowOptionImage) {
                <ms-participant-image
                    class="participant-logo"
                    [participantImage]="getParticipantImage(group?.options)"
                    [showLogoColor]="true"
                    [participantType]="isShowHeadshotImage ? participantType.Player : participantType.Team"
                    [sportId]="event.sport.id" />
            }
            <span class="goal-scorer-player-name">
                {{ group.attribute }}
                @if (
                    optionGroupPlayerStatisticsService.isSeasonStatisticsEnabled() &&
                    optionGroupPlayerStatisticsService.isPlayer(event, group.attribute)
                ) {
                    <ms-player-stats
                        [statistics]="optionGroupPlayerStatisticsService.playerStatistics()"
                        [marketId]="group.options[0]?.optionGroupId?.toString()"
                        [seasonStatisticsMessage]="seasonStatisticsMessage().hitRate"
                        [isSeasonStatisticsEnabled]="optionGroupPlayerStatisticsService.isSeasonStatisticsEnabled()"
                        [seasonStatisticsType]="SeasonStatisticsType.HitRate"
                        [optionId]="group.options[0]?.id?.toString()" />
                }
            </span>
            @if (
                optionGroupPlayerStatisticsService.isPlayerStatisticsEnabled() && optionGroupPlayerStatisticsService.isPlayer(event, group.attribute)
            ) {
                <div class="player-statistics-icon" [class.active]="isPlayerStatisticsOpen(group)" (click)="togglePlayerStatistics(group)">
                    <vn-icon size="12" [name]="isPlayerStatisticsOpen(group) ? 'sports-stats-active' : 'sports-stats'" />
                </div>
            }
        </div>
        @for (option of group.options; track trackOption($index, option)) {
            @if (option) {
                <ms-option
                    [ngClass]="{ 'player-image': isShowOptionImage }"
                    [tracking]="optionTracking(option)"
                    [option]="option"
                    [optionGroup]="optionGroup"
                    [event]="event"
                    [sourceOfPick]="sourceOfPick"
                    [betDetails]="betDetails" />
            } @else {
                <div class="option">
                    <div class="offline option-pick">
                        <div class="value">-</div>
                    </div>
                </div>
            }
        }

        @if (isPlayerStatisticsOpen(group)) {
            <ms-player-statistics
                [statistics]="optionGroupPlayerStatisticsService.playerStatistics()"
                [marketFilter]="optionGroup.originalId"
                [tracking]="tracking"
                [optionGroupName]="optionGroup.name"
                [messages]="playerStatisticsMessages()"
                [isSheetViewOpen]="optionGroupPlayerStatisticsService.isSheetViewOpen()"
                [event]="event"
                [marketId]="group.options[0]?.optionGroupId?.toString()"
                [playerName]="group.attribute"
                [optionId]="group.options[0]?.id?.toString()" />
        }
    </ng-container>
</div>
@if (!isInSheetView) {
    <ms-option-panel-bottom-action [data]="showMoreData()" (showMore)="onShowMore($event)" (showAllRequested)="showAllRequested.next()" />
}
